// extracted by css-extract-rspack-plugin
export default {"zone":"zone-8MRLi","padded":"padded-3uqqL","flexdiv":"flexdiv-24kyt","active":"active-1skR_","accept":"accept-1AaYS","reject":"reject-8cJSw"};